import { ReactElement } from 'react'
import { useCounterFromDate } from '$hooks/use-counter-from-date'

interface Props {
  interval: number
  stop: boolean
  renderer: (time: number) => ReactElement
}
export const Timer = ({ renderer, interval, stop }: Props) => {
  const time = useCounterFromDate({ stop, intervalMS: interval })

  return renderer(time)
}
